import { MoreHorizontal, RefreshCw, Trash2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface Props {
  onRegenerate?: () => void;
  onDelete?: () => void;
  /** Disable the trigger — e.g. while a mutation is in-flight. */
  disabled?: boolean;
}

/**
 * Compact "…" overflow menu used on each report/analysis row. Mirrors
 * the prototype pattern: Regenerate (Plus/Refresh icon) + destructive
 * Delete. Callers decide whether each action is available.
 */
export function ReportActionsMenu({ onRegenerate, onDelete, disabled }: Props) {
  if (!onRegenerate && !onDelete) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          className="flex h-[26px] w-[26px] items-center justify-center rounded-md border border-border text-muted-foreground transition-colors hover:bg-foreground/[0.04] hover:text-foreground disabled:opacity-50"
          title="More"
        >
          <MoreHorizontal className="h-3.5 w-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        {onRegenerate && (
          <DropdownMenuItem onClick={onRegenerate} className="gap-2">
            <RefreshCw className="h-3.5 w-3.5" />
            Regenerate
          </DropdownMenuItem>
        )}
        {onRegenerate && onDelete && <DropdownMenuSeparator />}
        {onDelete && (
          <DropdownMenuItem
            onClick={onDelete}
            className="gap-2 text-destructive focus:text-destructive"
          >
            <Trash2 className="h-3.5 w-3.5" />
            Delete this version
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
